// The selectors must match the configuration in noticeable

const TOP_BANNER_ID = 'V92cWJFxE4fuW7lMqWAf';
const NEWS_PAGE_EMBED_ID = 'T3Fyvz93qepKY6ANOrU6';

export const renderTopBanner = async (selector: string) => {
  await waitForElement(selector);
  window.noticeable.render('widget', TOP_BANNER_ID);
};

export const destroyTopBanner = async () => {
  window.noticeable.destroy('widget', TOP_BANNER_ID);
};

export const renderNewsPageEmbed = async (selector: string) => {
  await waitForElement(selector);
  window.noticeable.render('widget', NEWS_PAGE_EMBED_ID);
};

const waitForElement = (selector: string): Promise<HTMLElement> => {
  return new Promise(resolve => {
    const check = () => {
      const el = document.querySelector(selector) as HTMLElement;
      if (el) resolve(el);
      // eslint-disable-next-line no-undef
      else requestAnimationFrame(check);
    };
    check();
  });
};
